// TODO: Find the way to use it in Array.filter()

export default function isHtmlElementNode(node: Node, name: 'A'): node is HTMLAnchorElement & { tagName: 'A' };
export default function isHtmlElementNode(
    node: Node,
    name: 'BLOCKQUOTE',
): node is HTMLQuoteElement & { tagName: 'BLOCKQUOTE' };
export default function isHtmlElementNode(node: Node, name: 'BR'): node is HTMLBRElement & { tagName: 'BR' };
export default function isHtmlElementNode(node: Node, name: 'DIV'): node is HTMLDivElement & { tagName: 'DIV' };
export default function isHtmlElementNode(node: Node, name: 'H1'): node is HTMLHeadingElement & { tagName: 'H1' };
export default function isHtmlElementNode(node: Node, name: 'H2'): node is HTMLHeadingElement & { tagName: 'H2' };
export default function isHtmlElementNode(node: Node, name: 'H3'): node is HTMLHeadingElement & { tagName: 'H3' };
export default function isHtmlElementNode(node: Node, name: 'H4'): node is HTMLHeadingElement & { tagName: 'H4' };
export default function isHtmlElementNode(node: Node, name: 'H5'): node is HTMLHeadingElement & { tagName: 'H5' };
export default function isHtmlElementNode(node: Node, name: 'H6'): node is HTMLHeadingElement & { tagName: 'H6' };
export default function isHtmlElementNode(node: Node, name: 'HR'): node is HTMLHRElement & { tagName: 'HR' };
export default function isHtmlElementNode(
    node: Node,
    name: 'IFRAME',
): node is HTMLIFrameElement & { tagName: 'IFRAME' };
export default function isHtmlElementNode(node: Node, name: 'IMG'): node is HTMLImageElement & { tagName: 'IMG' };
export default function isHtmlElementNode(node: Node, name: 'LI'): node is HTMLLIElement & { tagName: 'LI' };
export default function isHtmlElementNode(node: Node, name: 'OL'): node is HTMLOListElement & { tagName: 'OL' };
export default function isHtmlElementNode(node: Node, name: 'P'): node is HTMLParagraphElement & { tagName: 'P' };
export default function isHtmlElementNode(node: Node, name: 'PRE'): node is HTMLPreElement & { tagName: 'PRE' };
export default function isHtmlElementNode(
    node: Node,
    name: 'SCRIPT',
): node is HTMLScriptElement & { tagName: 'SCRIPT' };
export default function isHtmlElementNode(
    node: Node,
    name: 'SOURCE',
): node is HTMLSourceElement & { tagName: 'SOURCE' };
export default function isHtmlElementNode(node: Node, name: 'STYLE'): node is HTMLStyleElement & { tagName: 'STYLE' };
export default function isHtmlElementNode(node: Node, name: 'TABLE'): node is HTMLTableElement & { tagName: 'TABLE' };
export default function isHtmlElementNode(node: Node, name: 'TD'): node is HTMLTableCellElement & { tagName: 'TD' };
export default function isHtmlElementNode(node: Node, name: 'TH'): node is HTMLTableCellElement & { tagName: 'TH' };
export default function isHtmlElementNode(node: Node, name: 'UL'): node is HTMLUListElement & { tagName: 'UL' };
export default function isHtmlElementNode(node: Node, name: 'VIDEO'): node is HTMLVideoElement & { tagName: 'VIDEO' };
export default function isHtmlElementNode(node: Node): node is HTMLElement;
export default function isHtmlElementNode(node: Node, name?: string | undefined): boolean {
    const isHTMLElement = node.nodeType === Node.ELEMENT_NODE;
    if (!name) return isHTMLElement;
    return isHTMLElement && (node as HTMLElement).tagName === name;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect, expectTypeOf } = import.meta.vitest;
    describe('isHtmlElementNode', () => {
        test('results with false for non-html elements', () => {
            expect(isHtmlElementNode(document)).toBe(false);
            expect(isHtmlElementNode(document.createProcessingInstruction('target', 'data'))).toBe(false);
            expect(isHtmlElementNode(document.createDocumentFragment())).toBe(false);
            expect(isHtmlElementNode(document.createAttribute('attr'))).toBe(false);
            expect(isHtmlElementNode(document.createTextNode('text'))).toBe(false);
            expect(isHtmlElementNode(document.createComment('comment'))).toBe(false);
            expect(isHtmlElementNode(document, 'A')).toBe(false);
        });

        test('results with true for html elements', () => {
            expect(isHtmlElementNode(document.body)).toBe(true);
            expect(isHtmlElementNode(document.createElement('a'))).toBe(true);
            expect(isHtmlElementNode(document.createElement('script'))).toBe(true);
            expect(isHtmlElementNode(document.createElement('link'))).toBe(true);
        });

        test('results with true only for html elements matching given tag name', () => {
            expect(isHtmlElementNode(document.createElement('a'), 'a' as 'A')).toBe(false);
            expect(isHtmlElementNode(document.createElement('a'), 'A')).toBe(true);
            expect(isHtmlElementNode(document.createElement('BLOCKQUOTE'), 'BLOCKQUOTE')).toBe(true);
            expect(isHtmlElementNode(document.createElement('br'), 'A')).toBe(false);
            expect(isHtmlElementNode(document.createElement('br'), 'BR')).toBe(true);
            expect(isHtmlElementNode(document.createElement('DIV'), 'DIV')).toBe(true);
            expect(isHtmlElementNode(document.createElement('H1'), 'H1')).toBe(true);
            expect(isHtmlElementNode(document.createElement('H2'), 'H2')).toBe(true);
            expect(isHtmlElementNode(document.createElement('H3'), 'H3')).toBe(true);
            expect(isHtmlElementNode(document.createElement('H4'), 'H4')).toBe(true);
            expect(isHtmlElementNode(document.createElement('H5'), 'H5')).toBe(true);
            expect(isHtmlElementNode(document.createElement('H6'), 'H6')).toBe(true);
            expect(isHtmlElementNode(document.createElement('HR'), 'HR')).toBe(true);
            expect(isHtmlElementNode(document.createElement('IFRAME'), 'IFRAME')).toBe(true);
            expect(isHtmlElementNode(document.createElement('IMG'), 'IMG')).toBe(true);
            expect(isHtmlElementNode(document.createElement('LI'), 'LI')).toBe(true);
            expect(isHtmlElementNode(document.createElement('OL'), 'OL')).toBe(true);
            expect(isHtmlElementNode(document.createElement('P'), 'P')).toBe(true);
            expect(isHtmlElementNode(document.createElement('PRE'), 'PRE')).toBe(true);
            expect(isHtmlElementNode(document.createElement('SCRIPT'), 'SCRIPT')).toBe(true);
            expect(isHtmlElementNode(document.createElement('SOURCE'), 'SOURCE')).toBe(true);
            expect(isHtmlElementNode(document.createElement('STYLE'), 'STYLE')).toBe(true);
            expect(isHtmlElementNode(document.createElement('TABLE'), 'TABLE')).toBe(true);
            expect(isHtmlElementNode(document.createElement('TD'), 'TD')).toBe(true);
            expect(isHtmlElementNode(document.createElement('TH'), 'TH')).toBe(true);
            expect(isHtmlElementNode(document.createElement('UL'), 'UL')).toBe(true);
            expect(isHtmlElementNode(document.createElement('VIDEO'), 'VIDEO')).toBe(true);
        });

        test('justifies type of the given node to match the result of comparison', () => {
            const node: Node = document;

            isHtmlElementNode(node, 'A')
                ? expectTypeOf(node).toMatchTypeOf<HTMLAnchorElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLAnchorElement>();

            isHtmlElementNode(node, 'BLOCKQUOTE')
                ? expectTypeOf(node).toMatchTypeOf<HTMLQuoteElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLQuoteElement>();

            isHtmlElementNode(node, 'BR')
                ? expectTypeOf(node).toMatchTypeOf<HTMLBRElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLBRElement>();

            isHtmlElementNode(node, 'DIV')
                ? expectTypeOf(node).toMatchTypeOf<HTMLDivElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLDivElement>();

            isHtmlElementNode(node, 'H1')
                ? expectTypeOf(node).toMatchTypeOf<HTMLHeadingElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLHeadingElement>();
            isHtmlElementNode(node, 'H2')
                ? expectTypeOf(node).toMatchTypeOf<HTMLHeadingElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLHeadingElement>();
            isHtmlElementNode(node, 'H3')
                ? expectTypeOf(node).toMatchTypeOf<HTMLHeadingElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLHeadingElement>();
            isHtmlElementNode(node, 'H4')
                ? expectTypeOf(node).toMatchTypeOf<HTMLHeadingElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLHeadingElement>();
            isHtmlElementNode(node, 'H5')
                ? expectTypeOf(node).toMatchTypeOf<HTMLHeadingElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLHeadingElement>();
            isHtmlElementNode(node, 'H6')
                ? expectTypeOf(node).toMatchTypeOf<HTMLHeadingElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLHeadingElement>();

            isHtmlElementNode(node, 'HR')
                ? expectTypeOf(node).toMatchTypeOf<HTMLHRElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLHRElement>();

            isHtmlElementNode(node, 'IFRAME')
                ? expectTypeOf(node).toMatchTypeOf<HTMLIFrameElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLIFrameElement>();

            isHtmlElementNode(node, 'IMG')
                ? expectTypeOf(node).toMatchTypeOf<HTMLImageElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLImageElement>();

            isHtmlElementNode(node, 'LI')
                ? expectTypeOf(node).toMatchTypeOf<HTMLLIElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLLIElement>();

            isHtmlElementNode(node, 'OL')
                ? expectTypeOf(node).toMatchTypeOf<HTMLOListElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLOListElement>();

            isHtmlElementNode(node, 'PRE')
                ? expectTypeOf(node).toMatchTypeOf<HTMLPreElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLPreElement>();

            isHtmlElementNode(node, 'SCRIPT')
                ? expectTypeOf(node).toMatchTypeOf<HTMLScriptElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLScriptElement>();

            isHtmlElementNode(node, 'SOURCE')
                ? expectTypeOf(node).toMatchTypeOf<HTMLSourceElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLSourceElement>();

            isHtmlElementNode(node, 'STYLE')
                ? expectTypeOf(node).toMatchTypeOf<HTMLStyleElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLStyleElement>();

            isHtmlElementNode(node, 'TABLE')
                ? expectTypeOf(node).toMatchTypeOf<HTMLTableElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLTableElement>();

            isHtmlElementNode(node, 'TD')
                ? expectTypeOf(node).toMatchTypeOf<HTMLTableCellElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLTableCellElement>();

            isHtmlElementNode(node, 'TH')
                ? expectTypeOf(node).toMatchTypeOf<HTMLTableCellElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLTableCellElement>();

            isHtmlElementNode(node, 'UL')
                ? expectTypeOf(node).toMatchTypeOf<HTMLUListElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLUListElement>();

            isHtmlElementNode(node, 'VIDEO')
                ? expectTypeOf(node).toMatchTypeOf<HTMLVideoElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLVideoElement>();
        });
    });
}

// #endregion
